import { defaultClient } from '@mint-sdk/api-core';
import { z } from 'zod';

import { MediaRowEntitiesResponseSchema } from '../shared/schemas/mediaRowEntities.js';

export type {
  MediaRowEntityItemType,
  MediaRowEntitiesResponseType,
} from '../shared/schemas/mediaRowEntities.js';

export const getMediaRowEntities = defaultClient.query({
  url: 'omni-trafficking/v1/external-data/media-row-entities/',
  method: 'GET',
  responseSchema: MediaRowEntitiesResponseSchema,
  processResponse(data) {
    return data?.data?.items;
  },
  querySchema: z.object({
    integrationId: z.string(),
    externalActivityEntityId: z.string().array().nullable(),
    externalPlatformEntityId: z.string().array().nullable(),
    externalPlatformEntityUuid: z.string().array().nullable(),
  }),
  snakeCaseQueryParams: true,
});
